{
    "apply": "Anwenden",
    "top_navbar__search-placeholder": "Suche nach Kunden, Artikeln, Aufträgen, etc.",
    "top_navbar__new_actvity": "Neue Aktivität",
    "top_navbar__new_task": "Neue Aufgabe",
    "top_navbar__new_draft": "Neuer Vorgang",
    "top_navbar__new_event": "Termin planen",
    "top_navbar__new_note": "Interaktion festhalten",
    "search__label__customers": "Kunden",
    "search__label__products": "Artikel",
    "search__label__sales_orders": "Aufträge",
    "search__label__sales_quotes": "Angebote",
    "search__label__all": "Alle",
    "search__clear": "Suche zurücksetzen",
    "search__match_label__contact": "Kontaktperson",
    "search__match_label__address": "Adresse",
    "search__match_label__supplier": "Lieferant",
    "search__match_label__purchase_order_number": "Bestellnummer",
    "search__match_label__po_number": "Kommission",
    "search__match_label__gtin": "GTIN",
    "search__match_label__ean": "EAN",
    "table_count_results_plural": "Ergebnisse",
    "table_count_results_singular": "Ergebnisse",
    "table_more_results": "Mehr anzeigen",
    "page_title__home": "Startseite",
    "page_title__customers": "Kunden",
    "page_title__product_details": "Produktdetails",
    "page_title__sales_quotes": "Angebote",
    "page_title__sales_orders": "Aufträge",
    "page_title__explorer": "Umsatzanalyse",
    "page_title__tasks": "Aufgaben",
    "page_title__drafts": "Entwürfe",
    "page_title__sales_drafts": "Entwürfe",
    "page_title__transactions": "Vorgänge",
    "page_title__events": "Termine",
    "page_title__activities": "Aktivitäten",
    "page_title__my_activity": "Meine Aktivitäten",
    "nav_group__steer": "Steuern",
    "nav_group__analyze": "Analysieren",
    "nav__expand": "Navigation ausklappen",
    "data_freshness__stale": "Daten möglicherweise veraltet",
    "data_freshness__stale_detail_one": "Seit über {{count}} Tag kein neuer Auftragseingang in Plato. Wende dich an deine IT, falls das Problem bestehen bleibt.",
    "data_freshness__stale_detail_other": "Seit über {{count}} Tagen kein neuer Auftragseingang in Plato. Wende dich an deine IT, falls das Problem bestehen bleibt.",
    "view_switch__view_as_label": "Ansicht",
    "view_switch__manager": "Manager",
    "view_switch__sales_rep": "Vertrieb",
    "view_switch__rep_only_page_toast": "Diese Seite ist nur in der Vertriebsansicht sichtbar",
    "view_switch__manager_only_page_toast": "Diese Seite ist nur in der Manager-Ansicht sichtbar",
    "page_sub_title__home": "Hier siehst du, wie dein Tag und dein Monat laufen und welche deiner Kunden gerade Aufmerksamkeit brauchen. Deine Zahlen von heute und aus dem Monat, fällige Aufgaben und Kunden mit Potenzial oder Rückgang. Ein Klick auf Kachel oder Kunde führt zu den Details.",
    "page_sub_title__customers": "Hier findest du, welche deiner Kunden als Nächstes einen Termin brauchen. Du siehst die Kunden, für die du zuständig bist, mit Zahlen und Status wie in deiner Warenwirtschaft. Die Schnellansichten oben sind fertige Listen dafür.",
    "page_sub_title__sales_quotes": "Hier behältst du im Blick, welche Angebote deiner Kunden noch offen sind und nachgefasst werden sollten. Sie stammen aus deiner Warenwirtschaft. Filtere die Liste, wie du sie brauchst, und speichere sie als Ansicht für das nächste Mal.",
    "page_sub_title__sales_orders": "Hier siehst du, was deine Kunden bestellt haben und ob ein Auftrag noch offen oder schon fakturiert ist. Die Aufträge stammen aus deiner Warenwirtschaft. Filtere die Liste, wie du sie brauchst, und speichere sie als Ansicht für das nächste Mal.",
    "page_sub_title__explorer": "Hier siehst du, womit du dein Geschäft machst und wo es gegenüber dem Vorjahr fehlt, nach Kunde, Artikel und mehr, wie in deiner Warenwirtschaft. Wähle eine Zeile als Filter, dann zeigen alle anderen Reiter nur noch, was dazugehört.",
    "page_sub_title__customer_explorer": "Hier siehst du, womit dieser Kunde sein Geschäft mit dir macht und wo es gegenüber dem Vorjahr fehlt, nach Artikel und mehr. Wähle eine Zeile als Filter, dann zeigen alle anderen Reiter nur noch, was dazugehört.",
    "page_sub_title__tasks": "Hier siehst du, was heute zu erledigen ist und was noch ansteht. Deine Aufgaben stehen unter Heute, Anstehend und Erledigt. Die rote Zahl in der Navigation zählt deine offenen Aufgaben, die heute oder früher fällig sind.",
    "page_sub_title__drafts": "Hier machst du weiter, wo du bei einem Angebot oder Auftrag aufgehört hast. Entwürfe hast du in Plato angefangen, aber noch nicht an die Warenwirtschaft übermittelt. Erst nach der Übermittlung stehen sie dort und zählen.",
    "page_sub_title__events": "Hier planst du deine Besuche und Besprechungen bei Kunden. Ein Termin zählt beim Kunden erst als Besuch, wenn du ihn danach protokollierst.",
    "page_sub_title__activities": "Protokollierte Interaktionen, erledigte Aufgaben, Vertriebsempfehlungen und Statusänderungen von Kunden im gesamten Team. Angebote und Aufträge sind nicht enthalten. Geplante Termine, offene Aufgaben und angeheftete Notizen erscheinen hier ebenfalls nicht: Du findest sie unter Aufgaben und auf der Kundenseite.",
    "page_sub_title__my_activity": "Deine protokollierten Interaktionen, erledigten Aufgaben, Vertriebsempfehlungen und Statusänderungen von Kunden. Angebote und Aufträge sind nicht enthalten. Geplante Termine, offene Aufgaben und angeheftete Notizen erscheinen hier ebenfalls nicht: Du findest sie unter Aufgaben und auf der Kundenseite.",
    "empty_table__no_results": "Keine Ergebnisse gefunden",
    "form__submit": "Bestätigen",
    "form__cancel": "Abbrechen",
    "form__close": "Schließen",
    "form__undo": "Rückgängig",
    "form__delete": "Löschen",
    "form__release": "Freigeben",
    "show_results": "Ergebnisse anzeigen",
    "show_more": "Mehr anzeigen",
    "show_less": "Weniger anzeigen",
    "no_data": "Keine Daten",
    "nothing_found": "Keine Ergebnisse",
    "loading": "Lädt",
    "loading_dots": "Lädt...",
    "submit": "Senden",
    "search": "Suche",
    "quote": "Angebot",
    "sales_quote": "Angebot",
    "order": "Auftrag",
    "sales_order": "Auftrag",
    "today": "Heute",
    "yesterday": "Gestern",
    "tomorrow": "Morgen",
    "difference": "Abweichung",
    "back": "Zurück",
    "ascending": "Aufsteigend",
    "descending": "Absteigend",
    "description": "Beschreibung",
    "logout__button": "Abmelden",
    "exit_demo__button": "Demo beenden",
    "support__button": "Hilfe",
    "customer_mode__button": "Deckungsbeiträge ausblenden",
    "placeholder__select_date": "Datum auswählen...",
    "placeholder__select_customer": "Suche nach Kunde",
    "form__customer_required": "Bitte wähle einen Kunden aus",
    "form__text_required": "Bitte Text eingeben",
    "form__date_required": "Bitte wähle ein Datum aus",
    "form__assignee_required": "Bitte wähle einen Nutzer aus",
    "related_to": "Bezug",
    "assigned_to_user": "zu erledigen von {{user}}",
    "vs_lytd": "zum Vorjahreszeitraum",
    "vs_previous_12_months": "zu den vorherigen 12 Monaten",
    "last_12_months": "Letzte 12 Monate",
    "previous_12_months": "Vorherige 12 Monate",
    "total_amount": "Gesamt",
    "assigned_to": "Zu erledigen von",
    "due_date": "Fällig bis",
    "task": "Aufgabe",
    "scheduled_by_user": "geplant von {{user}}",
    "logged_by_user": "protokolliert von {{user}}",
    "customer": "Kunde",
    "article": "Artikel",
    "product": "Artikel",
    "storage_location": "Lager",
    "sales_draft__new_form___title": "Neuer Vorgang",
    "sales_draft__new_form___storage_location": "Lager",
    "sales_draft__new_form___customer": "Kunde",
    "sales_draft__new_form___type": "Art",
    "sales_draft__new_form___order": "Auftrag",
    "sales_draft__new_form___quote": "Angebot",
    "erp_connection_error_banner___title": "Vorgangserstellung deaktiviert",
    "erp_connection_error_banner___description": "Plato kann sich nicht mit der Warenwirtschaft verbinden. Bitte kontaktiere deinen internen IT-Ansprechpartner.",
    "placeholder__select_storage": "Lager auswählen...",
    "backorder": "Lieferrückstand",
    "search_product": "Suche nach Artikeln",
    "copy_id_tooltip": "ID in die Zwischenablage kopieren",
    "copy_tooltip": "In die Zwischenablage kopieren",
    "all_changes_saved": "Alle Änderungen gespeichert",
    "saving_failed": "Speichern fehlgeschlagen",
    "time_picker__time_option": "{{time}} Uhr",
    "time_picker__placeholder": "Zeit auswählen",
    "toast__created_success_body": "Du kannst sie hier <linkTag>ansehen</linkTag>",
    "toast__edited_success_body": "Du kannst sie hier <linkTag>ansehen</linkTag>",
    "toast__deleted_success_body": "Du kannst eine neue <linkTag>hier</linkTag> erstellen",
    "filter_view_updated_title": "Ansicht gespeichert und angewandt.",
    "print": "Drucken",
    "show_all": "Alle anzeigen",
    "voice__start_recording": "Aufnahme starten",
    "voice__mic_error_title": "Aufnahme konnte nicht gestartet werden",
    "voice__mic_error_description": "Wir konnten nicht auf dein Mikrofon zugreifen. Bitte überprüfe die Berechtigungen deines Browsers und versuche es erneut.",
    "voice__transcription_error_title": "Aufnahme konnte nicht in Text umgewandelt werden",
    "voice__transcription_error_description": "Bitte versuche es erneut. Wenn das Problem bleibt, tippe deine Notiz ein.",
    "voice__recording_title": "Aufnahme",
    "voice__processing": "Aufnahme wird verarbeitet …",
    "voice__done": "Fertig",
    "rich_text_editor__enter_url": "URL eingeben:",
    "rich_text_editor__format_bold": "Fett",
    "rich_text_editor__format_italic": "Kursiv",
    "rich_text_editor__format_underline": "Unterstrichen",
    "rich_text_editor__format_strikethrough": "Durchgestrichen",
    "rich_text_editor__insert_bullet_list": "Aufzählungsliste",
    "rich_text_editor__insert_numbered_list": "Nummerierte Liste",
    "rich_text_editor__insert_link": "Link",
    "rich_text_editor__more_options": "Mehr Optionen",
    "rich_text_editor__clear": "Eingabe löschen",
    "rich_text_editor__improve_writing_loading": "Text wird verbessert",
    "rich_text_editor__improve_writing": "Text verbessern",
    "rich_text_editor__heading_summary": "Zusammenfassung",
    "rich_text_editor__heading_opportunities": "Chancen",
    "rich_text_editor__heading_feedback": "Feedback",
    "rich_text_editor__heading_next_steps": "Nächste Schritte",
    "rich_text_editor__rate_suggestion": "Wie findest du den Vorschlag?",
    "rich_text_editor__thumbs_up": "Daumen hoch",
    "rich_text_editor__thumbs_down": "Daumen runter",
    "rich_text_editor__alternative": "Alternative",
    "rich_text_editor__insert": "Einfügen",
    "rich_text_editor__feedback_thank_you": "Danke für dein Feedback",
    "show_details": "Details anzeigen",
    "status_new": "Neu",
    "status_active": "Aktiv",
    "status_at_risk": "Gefährdet",
    "status_inactive": "Inaktiv",
    "status_blocked": "Gesperrt",
    "status_dormant": "Ruhend",
    "view_customer": "Kunde anzeigen",
    "more": "mehr",
    "yes_no__true": "Ja",
    "yes_no__false": "Nein",
    "not_set": "Nicht eingestellt",
    "select_user": "Benutzer auswählen",
    "select_team_member": "Teammitglied auswählen",
    "you": "Du",
    "writeback_error": "Beim Herstellen der Verbindung zur Warenwirtschaft ist ein Fehler aufgetreten",
    "attachments__label": "Anhänge",
    "attachments__add_files": "Dateien hinzufügen",
    "attachments__load_error": "Datei konnte nicht geladen werden",
    "discard_changes__title": "Nicht gespeicherte Änderungen verwerfen?",
    "discard_changes__description": "Alle noch nicht gespeicherten Daten gehen verloren.",
    "discard_changes__confirm": "Änderungen verwerfen",
    "not_found_page__title": "Seite nicht gefunden",
    "not_found_page__description": "Leider konnten wir die gesuchte Seite nicht finden.",
    "not_found_page__back_home": "Zurück zur Startseite",
    "not_found_drawer__title": "Inhalt nicht gefunden",
    "not_found_drawer__description": "Leider konnten wir den gesuchten Inhalt nicht finden.",
    "error_page__title": "Fehler",
    "error_page__description": "Leider ist etwas schiefgelaufen (Fehler-ID: {{eventId}}):",
    "error_page__try_again": "Erneut versuchen",
    "mobile_nav__more": "Mehr",
    "nav__webshop": "Webshop",
    "carousel__previous_slide": "Vorherige Folie",
    "carousel__next_slide": "Nächste Folie",
    "aria__main_navigation": "Hauptnavigation",
    "aria__remove": "Entfernen",
    "aria__select_row": "Zeile auswählen",
    "aria__tabs": "Tabs"
}
